import React, { FC, useContext, useEffect } from 'react';
import IMarketingConsentFieldModel from '../../types/marketingConsentField.types';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { CustomFormContext } from '../customFormContextProvider';
import MarketingConsentCheckbox from './component/checkbox';
import useDidUpdate from '../../../../hooks/useDidUpdate.effect';

const MarketingConsentField: FC<ValueFieldProps<IMarketingConsentFieldModel>> = (props) => {
  const { field } = props;
  const id = field.valueField.id;
  const name = field.valueField.name;
  const hasAnyError = !!props.errors?.length;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const customFormContext = useContext(CustomFormContext);
  const [selectedCountry] = customFormContext?.selectedCountry ?? [];
  const isCountryISOCodePresent = selectedCountry == field.model?.marketoConsentCountryISOCode;
  const isConsentDefaultCountrySelected = field?.model?.marketoConsentDefaultCountrySelected;

  const preSelectedValue = () => {
    if (isCountryISOCodePresent || isConsentDefaultCountrySelected) {
      props.onChange(name, ('checkbox' + '|' + 'false') as string, props.isValid, []);
    } else {
      props.onChange(name, ('text' + '|' + 'false') as string, props.isValid, []);
    }
  };

  useDidUpdate(() => {
    preSelectedValue();
  }, [selectedCountry]);

  useEffect(() => {
    preSelectedValue();
  }, []);

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--checkboxfield ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      }`}
    >
      {isConsentDefaultCountrySelected ? (
        <MarketingConsentCheckbox {...props} />
      ) : (
        (!field.model?.marketoConsentCountryISOCode || selectedCountry) &&
        (isCountryISOCodePresent ? (
          <MarketingConsentCheckbox {...props} />
        ) : (
          <>
            <input id={id} name={name} className="sitecore-jss-form__field" type="hidden" value={props.value} form="novalidatedform" />
            <label htmlFor={id} className="sitecore-jss-form__control__label--checkbox-label-NoConsent ">
              <Text tag="span" field={{ value: field?.model?.marketoNoConsentValue }} editable={false} />
            </label>
          </>
        ))
      )}
      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  );
};

export default MarketingConsentField;
